export default __webpack_public_path__ + "static/media/insta-blue.4a4fa03a.svg";